import React, { useEffect } from 'react';
import moment from 'moment';

import useGlobal from '../../../../store';
import Table from '../../../../facturotopia/table/Table';

const mapState = (store) => {
  return {
    xml_storage: store.admin.reportes.facturacion.xml_storage,
  };
};

const mapActions = (actions) => {
  return actions.admin.reportes.facturacion.xml_storage;
};

const ReporteFacturacionXmlStorageList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state.xml_storage;
  const { cliente, fecha } = props;

  useEffect(() => {
    let from;
    let to;

    if (!!fecha) {
      from = moment(fecha).startOf('year').format('YYYY-MM-DD');
      to = moment(fecha).endOf('year').format('YYYY-MM-DD');
    } else {
      from = moment().startOf('month').format('YYYY-MM-DD');
      to = moment().format('YYYY-MM-DD');
    }

    const clienteId = !!cliente ? cliente : '';

    actions.paginate({
      page: 1,
      from: from,
      to: to,
      clienteId: clienteId,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (meta) => {
    actions.paginate(meta);
  };

  const handleOnPageChange = (page) => {
    const { from, to } = state.xml_storage.filters;

    paginate({ page, from, to });
  };

  const handleOnPageLimitChange = (limit) => {
    const { from, to } = state.xml_storage.filters;

    paginate({ limit, page: 1, from, to });
  };

  const getPaginationConfig = () => {
    const { pagination } = state.xml_storage;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  const { onRowClick } = props;

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      pagination={getPaginationConfig()}
      onRowClick={onRowClick}
      onRow={(item) => {
        return {
          className: item.highlight ? 'row-highlighted' : '',
        };
      }}
    ></Table>
  );
};

const columns = [
  {
    key: 'periodo',
    title: 'Periodo',
    dataIndex: 'periodo',
  },
  {
    key: 'cliente',
    title: 'Cliente',
    dataIndex: 'cliente',
  },
  {
    key: 'pac',
    title: 'Pac',
    dataIndex: 'pac',
  },
  {
    key: 'comprobantes',
    title: 'Comprobantes',
    dataIndex: 'comprobantes',
    className: 'text-right',
  },
  {
    key: 'retenciones',
    title: 'Retenciones',
    dataIndex: 'retenciones',
    className: 'text-right',
  },
  {
    key: 'cancelaciones',
    title: 'Cancelaciones',
    dataIndex: 'cancelaciones',
    className: 'text-right',
  },
];

export default ReporteFacturacionXmlStorageList;
